import { css } from '@emotion/css';
import { appColors, breakpoints } from '../styles/variables.style';

export const main = css`
  max-width: 1000px;
  margin: 40px auto;
  padding: 10px;
  font-size: 15px;
  line-height: 1.5em;
  font-family: 'Roboto', sans-serif;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);

  @media (min-width: ${breakpoints.lg.up}) {
    padding: 20px;
  }

  h2 {
    margin-bottom: 1.5em;
  }

  h3,
  h4 {
    margin-bottom: 0.7em;
  }

  ul,
  ol {
    margin: revert;
    padding: revert;

    li {
      margin-bottom: 15px;
    }
  }

  a {
    color: ${appColors.orange};
  }

  .important {
    background: #fffabc;
  }

  p {
    margin-bottom: 1.5em;
  }
`;
